import { render, staticRenderFns } from "./GovernanceFoundInfoWin.vue?vue&type=template&id=4e38ba37&"
import script from "./GovernanceFoundInfoWin.vue?vue&type=script&lang=js&"
export * from "./GovernanceFoundInfoWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports